// Voorleesknop op het bord: de schakelaar per gezinslid (readAloudApp.nl.ts).
export const appReadAloudFr = {
    setting: 'Bouton de lecture sur le tableau',
    settingHint: 'Un grand bouton lit à voix haute les tâches, les rendez-vous et les messages. Pratique pour ceux qui ne lisent pas encore.',
    language: 'Langue de lecture et des appels',
    languageHint: 'Le tableau lit les tâches, les rendez-vous et les appels dans cette langue. Les titres sont lus tels que vous les tapez.',
    languageBoard: 'Langue du tableau ({language})',
    languageMember: 'Langue de lecture',
    languageMemberHint: 'Les titres sont lus tels que vous les tapez.',
    languageFamily: 'Comme la famille ({language})',
    saved: 'Enregistré',
};
//# sourceMappingURL=readAloudApp.fr.js.map